<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="active section" v-on:click="goTo('/stats')">Estadísticas</a>
  </div>
  <h1 class="ui header"><i class="icon chart bar"></i><div class="content">Estadísticas: {{year}} </div></h1>
  <div class="rightButton">
    <a class="section" v-on:click="getStatsApms(year-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="getStatsApms(year+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div class="ui tabular menu">
    <a class="item " v-on:click="goTo('/stats')">
      Todos
    </a>
    <a class="item active" v-on:click="goTo('/stats/apms')">
      APMS
    </a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
      <!--  <chartjs-line :labels="mylabels" :datasets="mydatasets"></chartjs-line>-->
        <vue-good-table :columns="zutabeak" :rows="ilarak" :lineNumbers="true" @on-row-click="apmStats" styleClass="vgt-table striped condensed bordered">
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'apm'">
              <span style="font-weight: bold;color:black">{{props.row.apm}}</span>
            </span>
            <span v-else>
              {{props.formattedRow[props.column.field]}}
            </span>
          </template>
        </vue-good-table>
      </div>
      </div>
    </div>
  </div>

</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statApm',
  data() {
    return {
      data: null,
      year: null,
      zutabeak: null,
      ilarak: null,
    }
  },
  created() {
    let year = new Date().getFullYear()
    this.getStatsApms(year)
  },
  methods: {
    getStatsApms(year) {
      this.data = null
      this.year = year
      hapiickApi().post('/v2/stats/apms', {
        admin_id: JSON.parse(localStorage.admin).id,
        year: year
      })
      .then(request => this.updateStatistics(request))
      .catch((request) => console.log('error getting stats:' + request))
    },
    updateStatistics(req) {
      this.zutabeak = []
      this.ilarak = []
      this.last_month = 12;
      this.data = JSON.parse(JSON.stringify(req.data.data))

      let hoy = new Date();
      let current_year = hoy.getFullYear();
      let datuak = this.data.monthPicks.slice();

      if (this.year == current_year) {
        this.last_month = hoy.getMonth() + 1;
      }

      this.zutabeak.push({
        label: 'APM',
        field: 'apt_name',
        filterOptions: {
          placeholder: 'APM',
          enabled: true, // enable filter for this column
        },
      })
     
      for (let i = 0; i < this.last_month; i++) {
        this.zutabeak.push({
          'label': this.$months[i],
          'field': this.$months[i],
          'type': 'number',
        })
      }
      this.zutabeak.push({
        'label': 'Total',
        'field': 'Total',
        'type': 'number',
      })
      this.ilarak = datuak;
    },
    apmStats(params) {
      this.goTo('/apms/stats/' + params.row.apt_id)
    },
    goTo(where) {
      this.$router.push(where)
    },
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stats/statsApm.vue